module.exports = __webpack_public_path__ + "img/trinidad_sour.b0d4e48e.jpg";